import React from 'react';
import { CorrespondenceAnswers } from './ActivityAnswers/CorrespondenceAnswers';
import { StandardAnswers } from './ActivityAnswers/StandardAnswers';
import { WordCollectionAnswers } from './ActivityAnswers/WordCollectionAnswers';
import SeekAndFindAnswer from './ActivityAnswers/SeekAndFindAnswer';
import FlashCardAnswer from './ActivityAnswers/FlashCardAnswer';
import FroggyJumpAnswer from './ActivityAnswers/FroggyJumpAnswer';
import { StyledXCard } from '../../Styled-Components';

export const ActivityAnswers = ({
    activityInfo,
    setActivityInfo,
    setIsActivityInfoUpdated,
    userActivityId,
    SETTINGS,
    TEMPLATE,
    TOOLTIPS,
    saveActivity,
    charCount,
    setCharCount,
    ...props
}) => {
    const ACTIVITY_TYPE = activityInfo?.type;

    if (TEMPLATE.STANDARD.includes(ACTIVITY_TYPE)) {
        return (
            <StandardAnswers
                activityInfo={activityInfo}
                setActivityInfo={setActivityInfo}
                setIsActivityInfoUpdated={setIsActivityInfoUpdated}
                ACTIVITY_TYPE={ACTIVITY_TYPE}
                SETTINGS={SETTINGS}
                TOOLTIPS={TOOLTIPS}
                charCount={charCount}
                setCharCount={setCharCount}
            />
        )
    } else if (TEMPLATE.CORRESPONDENCE.includes(ACTIVITY_TYPE)) {
        return (
            <CorrespondenceAnswers
                activityInfo={activityInfo}
                setActivityInfo={setActivityInfo}
                setIsActivityInfoUpdated={setIsActivityInfoUpdated}
                ACTIVITY_TYPE={ACTIVITY_TYPE}
                SETTINGS={SETTINGS}
            />
        )
    } else if (TEMPLATE.WORD_COLLECTION.includes(ACTIVITY_TYPE)) {
        return (
            <WordCollectionAnswers
                activityInfo={activityInfo}
                setActivityInfo={setActivityInfo}
                setIsActivityInfoUpdated={setIsActivityInfoUpdated}
                ACTIVITY_TYPE={ACTIVITY_TYPE}
                SETTINGS={SETTINGS}
            />
        )
    } else if (TEMPLATE.SELECTION_IMAGE.includes(ACTIVITY_TYPE)) {
        return (
            <SeekAndFindAnswer
                activityInfo={activityInfo}
                setActivityInfo={setActivityInfo}
                userActivityId={userActivityId}
                setIsActivityInfoUpdated={setIsActivityInfoUpdated}
                saveActivity={saveActivity}
                TOOLTIPS={TOOLTIPS}
            />
        )
    } else if (TEMPLATE.FLASH_CARD.includes(ACTIVITY_TYPE)) {
        return (
            <FlashCardAnswer
                activityInfo={activityInfo}
                setActivityInfo={setActivityInfo}
                setIsActivityInfoUpdated={setIsActivityInfoUpdated}
                TOOLTIPS={TOOLTIPS}
            />
        )
    } else if (TEMPLATE.FROGGY_JUMP.includes(ACTIVITY_TYPE)) {
        return (
            <FroggyJumpAnswer
                activityInfo={activityInfo}
                setActivityInfo={setActivityInfo}
                setIsActivityInfoUpdated={setIsActivityInfoUpdated}
            />
        )
    } else {
        return (
            <StyledXCard
                isCollapsable={false}
                title='Answers'
                style={{margin: '2em 3em'}}
            >
                <p style={{ textAlign: 'center', color: 'blue' }}>Area Under Construction</p>
            </StyledXCard>
        )
    }
};

